import {
  Pagination,
  PaginationProps,
  Stack,
  TablePagination,
  TablePaginationProps,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { FC } from "react";
import { ICustomPaginationProps } from "../interfaces/pagination";

export const CustomPagination: FC<ICustomPaginationProps> = (props) => {
  const { type, paginationProps } = props;
  const theme = useTheme();
  const largeMediumScreen = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <>
      {type === "card-list" && (
        <Pagination
          {...(paginationProps as PaginationProps)}
          variant="outlined"
        />
      )}
      {type === "table" && (
        <Stack alignItems="center" borderTop={"1px solid rgba(224, 224, 224, 1)"}>
          <TablePagination
            align="center"
            component="div"
            {...(paginationProps as TablePaginationProps)}
            rowsPerPageOptions={largeMediumScreen ? (paginationProps as TablePaginationProps).rowsPerPageOptions : []}
          />
        </Stack>

      )}
    </>
  );
};
